import { enUS as en, ru } from 'date-fns/locale';
import { FormControl, FormHelperText, FormLabel } from '@mui/material';
import { CalendarToday } from '@mui/icons-material';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFns';
import { SingleInputDateTimeRangeField } from '@mui/x-date-pickers-pro/SingleInputDateTimeRangeField';
import { withControl } from '@features/effector-form/hoc/withControl';
import { getSafePickerLocale } from '@shared/utils/getSafePickerLocale';
import { theme } from '@unicorn/bms-theme';

const EN = 'en';
const LNG = localStorage.getItem('lang') || EN;

export const DateTimeRangeControl = withControl(
  ({ value, setValue, error, label, required, readOnly, disabled, isError }) => (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={LNG === EN ? en : ru}
      localeText={getSafePickerLocale(LNG)}
    >
      <FormControl required={required} disabled={disabled}>
        {label && <FormLabel error={isError}>{label}</FormLabel>}
        <SingleInputDateTimeRangeField
          value={value}
          onChange={(newValue) => setValue(newValue)}
          InputProps={{
            readOnly,
            disabled,
            error: isError,
            endAdornment: <CalendarToday sx={{ color: theme.palette.action.active }} />,
          }}
          readOnly={readOnly}
          disabled={disabled}
          size="small"
        />
        {error && <FormHelperText error>{error}</FormHelperText>}
      </FormControl>
    </LocalizationProvider>
  )
);
